// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".open-cprom-button-openCpromButton-d8d57{display:inline-block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"openCpromButton": "open-cprom-button-openCpromButton-d8d57"
};
export default ___CSS_LOADER_EXPORT___;
